import { ChangeDetectorRef, Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';

import { PerfectScrollbarModule } from 'perfect-scrollbar-angular';
import { AdjustMenuPositionDirective } from 'src/app/Directives/adjustMenuPosition.directive';
import { TooltipDirective } from 'src/app/Directives/tooltip.directive';
import { SafePipe } from 'src/app/Pipes/safe.pipe';
import { CMD_ACTIONS, CMD_TARGETS, CmdRouterService } from 'src/app/services/cmd-router.service';
import { MapService } from 'src/app/services/map.service';

@Component({
  selector: 'ins-multiple-sites-menu',
  templateUrl: './multiple-sites-menu.component.html',
  styleUrls: ['./multiple-sites-menu.component.scss'],
  imports: [AdjustMenuPositionDirective, PerfectScrollbarModule, TooltipDirective, SafePipe]
})
export class MultipleSitesMenuComponent implements OnInit {
  public multipleSites: any = [];
  public position: any = {x: 0, y: 0};
  public showMenu: boolean = false;
  constructor(private readonly mapService: MapService, private readonly cdr: ChangeDetectorRef, 
    private cmdRouterService: CmdRouterService) { }

    ngOnInit(): void {
     this.mapService.multipleSitesChange.subscribe( (res: any) => {
        this.showMenu = false;
        this.multipleSites = res.multipleSites;
        this.position = res.position;
        requestAnimationFrame(() => this.showMenu = this.multipleSites.length > 0);
    });
  }

  public openSite($event, marker) {
    this.cmdRouterService.sendActionCmd(CMD_TARGETS.MAP_MANAGER, CMD_ACTIONS.OPEN_SITE, {event: $event, marker: marker});
  }

  public getToolTipConf(element: any, label: string): any {
    let toolTipConf = { text: '', position: { H: 'hLeft', V: 'vBottom' }, type: 'info' };
    if (element.offsetWidth < element.scrollWidth) {
      toolTipConf.text = label;
    }
    return toolTipConf;
  }

}
